import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import Modal from '../../../../../components/shared/Modal/Modal';
import { PurchaseOrder } from '../../../../../types/PurchaseOrder.types';

interface RejectReasonModalProps {
  order: PurchaseOrder | null;
  isSaving: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

// El motivo viaja en purchase_orders_reject?reason y el backend lo añade a la
// nota del historial, así que se exige: sin él, el solicitante no sabría por qué
// le devuelven la orden a borrador. Modal no admite deshabilitar el botón, por
// eso se valida en onConfirm.
export const RejectReasonModal = ({ order, isSaving, onConfirm, onCancel }: RejectReasonModalProps) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  // El componente queda montado entre aperturas: se limpia al cambiar de orden.
  useEffect(() => { setReason(''); setError(''); }, [order && order.id]);

  const handleConfirm = () => {
    if (isSaving) return;
    if (!reason.trim()) {
      setError('Indique el motivo del rechazo.');
      return;
    }
    onConfirm(reason.trim());
  };

  return (
    <Modal
      isOpen={!!order}
      type="warning"
      title="Rechazar orden de compra"
      message={order ? `La orden ${order.poNumber} volverá a borrador para que ${order.createdByName || 'el solicitante'} la corrija.` : undefined}
      confirmText={isSaving ? 'Rechazando...' : 'Rechazar'}
      cancelText="Cancelar"
      onConfirm={handleConfirm}
      onCancel={onCancel}
    >
      <div className="module-space-y-3">
        {error && (
          <div className="module-form-error">
            <AlertCircle size={14} style={{ flexShrink: 0 }} />
            <span>{error}</span>
          </div>
        )}
        <div className="module-form-group">
          <label className="module-form-label">Motivo *</label>
          <textarea
            rows={3}
            value={reason}
            onChange={(e) => { setReason(e.target.value); if (error) setError(''); }}
            placeholder="Precio fuera de presupuesto, acreedor no homologado..."
            className="module-form-textarea"
            autoFocus
          />
        </div>
      </div>
    </Modal>
  );
};
